export default __webpack_public_path__ + "static/media/promo_03.30a289ae.jpg";